import { css, jsx } from '@emotion/core';
import { Checkbox } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleFormChange, handleFormUpdate } from '@/src/register/redux/registerAccountReducer';

// import { setInputFieldInfo, toggleCheckbox } from '@/src/register/redux/registerActions';
import Label from './Label';

const styles = {
  checkboxInfoContainer: css`
    max-width: 36.5rem;
    width: 100%;
    margin: 1.6rem 0;
  `,
  checkboxLabelText: css`
    font-size: 1.2rem;
    font-weight: 900;
    margin-left: 8px;
  `,
};

const APCIACheckbox = props => {
  const { form, info, step, isToggled } = props;

  const dispatch = useDispatch();

  const { register } = useSelector(state => state);

  useEffect(() => {
    if (isMailingAddressDisabled) {
      form.validateFields(['PoBoxNumber', 'PoBoxCity', 'PoBoxStateCode', 'PoBoxPostalCode'], {
        force: true,
      });
    }
  }, [isMailingAddressDisabled]);

  const { isMailingAddressDisabled } = register;
  const onChange = e => {
    const {
      target: { checked },
    } = e;

    if (checked) {
      dispatch(handleFormChange({ name: 'isMailingAddressDisabled', value: true }));
      form.setFieldsValue({
        PoBoxNumber: '',
        PoBoxCity: '',
        PoBoxStateCode: '',
        PoBoxState: '',
        PoBoxPostalCode: '',
      });
      dispatch(
        handleFormUpdate({
          PoBoxNumber: '',
          PoBoxCity: '',
          PoBoxStateCode: '',
          PoBoxState: '',
          PoBoxPostalCode: '',
        })
      );
    } else {
      dispatch(handleFormChange({ name: 'isMailingAddressDisabled', value: false }));
    }
  };

  const { checkboxLabel } = info;
  return (
    <div css={styles.checkboxInfoContainer}>
      <Label info={info} />
      <div>
        <Checkbox onChange={e => onChange(e)} checked={isMailingAddressDisabled} />
        <span css={styles.checkboxLabelText}>{checkboxLabel}</span>
      </div>
    </div>
  );
};

export default APCIACheckbox;
